export default __webpack_public_path__ + "static/media/indiana 1.2deb42a2.JPG";